.dda-slider-container {
  position: relative;
  width: 100%;
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  border-radius: 8px;
}

.dda-slider {
  position: relative;
  width: 100%;
  height: 450px;
}

.dda-slide {
  position: absolute;
  width: 100%;
  height: 100%;
  opacity: 0;
  /* transition: opacity 0.5s ease-in-out; */
  display: flex;
  justify-content: center;
  align-items: center;
}

.dda-slide.active {
  opacity: 1;
  z-index: 1;
}

.dda-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dda-slide video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.dda-video-play-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 5;
  background-color: rgba(0, 0, 0, 0.2);
}

.dda-video-play-overlay svg {
  width: 64px;
  height: 64px;
  /* transition: transform 0.3s ease; */
}

.dda-video-play-overlay:hover svg {
  transform: scale(1.2);
}

.dda-slider-controls-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 15px;
}

.dda-slider-prev, .dda-slider-next {
  background-color: rgba(255, 255, 255, 0.2);
  color: black;
  padding: 10px 15px;
  cursor: pointer;
  font-size: 18px;
  border: none;
  border-radius: 5px;
  /* transition: background-color 0.3s; */
  z-index: 2;
}

.dda-slider-prev:hover, .dda-slider-next:hover {
  background-color: rgba(255, 255, 255, 0.4);
}

.dda-slider-indicator-container {
  display: flex;
  justify-content: center;
}

.dda-slider-indicator {
  width: 24px;
  height: 24px;
  margin: 0 5px;
  cursor: pointer;
  /* transition: all 0.3s; */
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.dda-slider-indicator svg {
  width: 24px;
  height: 24px;
  display: block;
}

.dda-slider-timer-circle {
  stroke-dasharray: 63;
  stroke-dashoffset: 63;
  /* transition: none; */
}

.dda-slider-play-icon, .dda-slider-pause-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
}

.dda-slider-play-pause-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  z-index: 2;
}

@media (prefers-reduced-motion: no-preference) {
  .dda-slide {
    transition: opacity 0.5s ease-in-out;
  }
  .dda-video-play-overlay svg {
  transition: transform 0.3s ease;
  }
  .dda-slider-prev, .dda-slider-next {
    transition: background-color 0.3s;
  }
  .dda-slider-indicator {
    transition: all 0.3s;
  }
  .dda-slider-timer-circle {
    transition: none;
  }
}